import { useRef, useEffect } from 'react';
import { useController } from "react-hook-form";
import { getError } from '../../../utils/FormError';
import { useFormContext } from 'react-hook-form';

const Textarea = ({ 
	name, 
	placeholder = "", 
	control, 
	validationRules = {},
	className
}) => {
	const { formState: { errors } } = useFormContext();
	const error = getError(errors, name);
	const textareaRef = useRef(null);
	const {
	    field: { onChange, onBlur, value, ref },
	  } = useController({
	    name,
	    control,
	    rules: validationRules,
	    defaultValue: ''
	});

	const autoResize = () => {
		const el = textareaRef.current;
		if (el) {
			el.style.height = 'auto';
			el.style.height = el.scrollHeight + 'px';
		}
	};

	useEffect(() => {
		autoResize();
	}, [value]);

	const handleChange = (e) => {
		if(typeof onChange == 'function') {
			onChange(e);
		}
		
		autoResize();
	};

	return (
		<>
			<textarea
				ref={textareaRef}
				name={name}
				className={`form-control ${className} ${error ? 'is-invalid' : ''}`}
				placeholder={placeholder}
				onChange={handleChange}
				style={{ overflow: 'hidden', resize: 'none' }}
				defaultValue={value}
			/>
			{error && (
		        <div className="invalid-feedback">
		          {error.message}
		        </div>
		    )}
		</>
	);
};

export default Textarea;
